/**
 * @generated SignedSource<<543e097537f12a221431c61a9d2d058f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserEventsUpcomingSection_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EventList_query">;
  readonly " $fragmentType": "UserEventsUpcomingSection_query";
};
export type UserEventsUpcomingSection_query$key = {
  readonly " $data"?: UserEventsUpcomingSection_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserEventsUpcomingSection_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserEventsUpcomingSection_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventList_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "6d8156dc9565a3ef51c684130c1db428";

export default node;
